.icon {
  font-weight: 700;
  line-height: 1.5;
}

.in-circle {
  width: 3em;
  height: 3em;
  vertical-align: middle;
}

.checkmark {
  transform-origin: 50% 50%;
}

.checkmark-check {
  stroke: currentColor;
}

.animate {
  stroke-dasharray: 40;
  stroke-dashoffset: 40;
  animation: stroke .375s ease forwards;
  animation-delay: .25s;

  @keyframes stroke {
    100% { stroke-dashoffset: 0; }
  }
}
